import React from 'react'
import PropTypes from 'prop-types'
import { SealWarning } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '../../../../helpers/get-asset-link'

const ResidentCell = ({ row }) => {
  const { t } = useTranslation(['maintenance'])
  const { clientId, unit, shortDescription, priority, category, location } = row.original || {}

  return (
    <div
      className={`ctp-maintenance-requests-list__address-cell ${!clientId ? 'center-cell' : ''}`}
    >
      {clientId ? (
        <React.Fragment>
          <img
            src={getAssetLink({
              path: 'chitown-avatar/avatar',
              file: clientId?.avatar,
              fallback: { file: 'avatar.png' },
            })}
            alt={t('maintenance:requests.cells.userAvatarAlt')}
          />
          <div className="ctp-maintenance-requests-list__client-info-wrapper">
            <span>{`${clientId.firstName} ${clientId.lastName}`}</span>
            <span className="ctp-maintenance-requests-list__address-info">{clientId.email}</span>
          </div>
          {priority === 'Emergency' && (
            <div className="ctp-maintenance-requests-list__icon-wrap">
              <SealWarning size={20} />
            </div>
          )}
        </React.Fragment>
      ) : unit ? (
        <div className="ctp-maintenance-requests-list__client-info-wrapper">
          <span>{t('maintenance:requests.cells.unitNumber', { unit })}</span>
        </div>
      ) : shortDescription ? (
        <div className="ctp-maintenance-requests-list__client-info-wrapper">
          <span>{shortDescription}</span>
        </div>
      ) : location ? (
        <div className="ctp-maintenance-requests-list__client-info-wrapper">
          <span>{location}</span>
        </div>
      ) : (
        <div className="ctp-maintenance-requests-list__client-info-wrapper">
          <span>{category}</span>
        </div>
      )}
    </div>
  )
}

ResidentCell.propTypes = {
  row: PropTypes.object,
}

export default ResidentCell
